<template>
  <div>
    <PersonalData v-if="canPersonalDataView || canPersonalDataEdit"></PersonalData>
    <br v-if="canPersonalDataView || canPersonalDataEdit"/>
    <Password></Password>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import PersonalData from "@/views/Profile/PersonalData";
import Password from "@/views/Profile/Password";
export default {
  name: "Profile",
  components: {
    PersonalData,
    Password
  },
  computed:{
    ...mapGetters(["canPersonalDataView", "canPersonalDataEdit"])
  }
};
</script>
